<ngx-contentful-rich-text
  [document]="body"
  [nodeRenderers]="nodeRenderers"
  *ngIf="body"
></ngx-contentful-rich-text>
<ng-content select="[body]"></ng-content>
<div class="callout-details" *ngIf="leftSide || rightSide">
  <div class="callout-details-block" *ngIf="leftSide">
    <ngx-contentful-rich-text
      [document]="leftSide"
      [nodeRenderers]="nodeRenderers"
    ></ngx-contentful-rich-text>
    <ng-content select="[left-side]"></ng-content>
  </div>
  <div class="callout-details-block" *ngIf="rightSide">
    <ngx-contentful-rich-text
      [document]="rightSide"
      [nodeRenderers]="nodeRenderers"
    ></ngx-contentful-rich-text>
    <ng-content select="[right-side]"></ng-content>
  </div>
</div>
